module.exports = __webpack_public_path__ + "img/loginBg.79f71350.png";